import {
    getOpenOpportunitiesCountByOpportunityType,
    getOpportunities,
    getOpportunitiesAndBondsFilters,
} from '@services/opportunities.service';
import {
    transformOpportunityListingData,
    transformOpportunityListingDataLoggedInView,
} from './format-response';

import { getOpportunitiesCountByOpportunityType } from '@services/opportunities.service';
import useOpportunitiesStore from '@components/OpportunityListing/store/useOpportunitiesStore.js';

export const fetchOpportunitiesStats = async (filters, persistData) => {
    const { status } = filters;
    try {
        if (persistData) {
            return persistData;
        }

        const response = useOpportunitiesStore.getState().isAuthorized
            ? await getOpportunitiesCountByOpportunityType(status)
            : await getOpenOpportunitiesCountByOpportunityType();

        if (!response?.status) {
            throw new Error(
                response?.message || 'Failed to fetch opportunities count.'
            );
        }

        return response.entity; // Return structured data
    } catch (error) {
        console.error(
            `❌ Error fetching ${status} opportunities stats:`,
            error
        );
        throw new Error(
            `Failed to fetch stats for status: ${status}. ${error.message}`
        );
    }
};

export const fetchFilteredOpportunities = async (filters) => {
    const { page, limit, status, type } = filters;

    try {
        if (useOpportunitiesStore.getState().isAuthorized) {
            const { page, ...filteredFilters } = filters;
            const response = await getOpportunities(
                {
                    status,
                    type,
                    pageNo: page,
                    limit,
                    ...filteredFilters,
                },
                false
            );

            if (!response?.status) {
                throw new Error(
                    response?.message || 'Failed to fetch opportunities.'
                );
            }

            return {
                count: response?.entity?.count,
                status,
                rows: transformOpportunityListingDataLoggedInView(
                    response.entity.rows
                ),
            };
        }

        const response = await getOpportunitiesAndBondsFilters(
            {
                status,
                type,
                page,
                limit,
                ...filters,
            },
            false
        );

        if (!response?.status) {
            throw new Error(
                response?.message || 'Failed to fetch opportunities.'
            );
        }

        return {
            count: response.entity.count,
            status,
            rows: transformOpportunityListingData(response.entity.rows),
        };
    } catch (error) {
        console.error(`Error fetching ${status} investments:`, error);
        throw new Error(
            `Failed to fetch investments for status: ${status}. ${error.message}`
        );
    }
};
